import type { Toast } from '@/hooks/useToasts'

export function ToastHost({
  toasts,
  onDismiss
}: {
  toasts: Toast[]
  onDismiss?: (id: string) => void
}) {
  return (
    <div className="toast-host" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind || ''}`} role="status">
          <span className="toast-msg">
            {t.message}
            {t.count && t.count > 1 ? ` ×${t.count}` : ''}
          </span>
          {onDismiss ? (
            <button
              type="button"
              className="toast-x"
              aria-label="Dismiss"
              onClick={() => onDismiss(t.id)}
            >
              ×
            </button>
          ) : null}
        </div>
      ))}
    </div>
  )
}
